import React from 'react';
import '../App.less';
import { Link } from "react-router-dom";
import { 
    Button,
    Image,
    Typography, 
    Divider, 
    Statistic,
    Tag,
    Row, 
    Col,
    Space,
    PageHeader,
    Avatar,
    Alert
} from 'antd';

import { AntDesignOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;



function footUI() {
  return (
    <div>
        <Row className="m48-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                
                    <Row className="m80-b">
                        <Link to="/">
                            <PageHeader
                                onBack={() => null}
                                title="Back to Home"
                            />
                        </Link>
                    </Row>

                    <Row className="m16-b">
                        <Title>Foot UI - Tactical Urbanism</Title>
                    </Row>

                    <Row className="m24-b m24-t">
                        <Col>
                            <Text>
                                Foot UI is a set of explorations on how to create casual interactions between people in public spaces in a way that encourages distancing and safety. Along with research and concept generation, my role was mainly to prototype to ask questions. This was the first time I had gone beyond the screen onto the world, far away from finger swipes. I thoroughly enjoyed creating and envisioning a future which involves foot interactions.
                            </Text>  
                        </Col>
                    </Row>

                    <Row justify="space-between">
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Advisors</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/valdezyoung/" target="_blank" rel="noopener noreferrer">Adriana Valdez Young</a>, 
                                    <a className="nameLinkColor" href="http://vinaykmysore.com/" target="_blank" rel="noopener noreferrer"> Vinay Kumar</a>, 
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/aliasamy/" target="_blank" rel="noopener noreferrer"> Amy Wang</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/quise/" target="_blank" rel="noopener noreferrer"> Marquise Stillwell</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Team</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/aakashdewan" target="_blank" rel="noopener noreferrer">Aakash Dewan</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/julianjimsa/" target="_blank" rel="noopener noreferrer"> Julian Jimsa</a>, 
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/norrishung/" target="_blank" rel="noopener noreferrer"> Norris Hung</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Sustainable development goals</Text>
                                <Space className="m8-t">
                                    <Image className="sdgImage" src={`../pubAssets/sdg-3.png`}/>
                                </Space>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Tags</Text>
                                <Space size={1}>
                                    <Tag>Processing</Tag>
                                    <Tag>Projection Map</Tag>
                                </Space>
                                <Space>
                                    <Tag>CIID</Tag>
                                </Space>
                            </Space>
                        </Col>
                    </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        <Row>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Image src={require("../assets/projects/footui/footui_13.gif")}/>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
        
        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                            <Text className="projectTitle">challenge</Text>
                            <Text>
                                We were asked by the faculty to take a walk on the first day around San Jose, which led to identifying the following challenges.
                                <div className="m16-t">
                                    <ul>
                                        <li>People make an effort to avoid each other. Makes it feel like there is no community.</li>
                                        <li>San Jose people are just starting to create a sense of belonging.</li>
                                        <li>Could we create a playful urban intervention that brought back a little bit of engagement?</li>
                                    </ul>   
                                </div>
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                            <Text className="projectTitle">outcome</Text>
                            <Text>
                            FootUI explores different ways in which the distanced line markers at grocery stores and banks could act as a space where people could interact. Through projection mapping, Foot UI creates light and safe interactions using only one’s feet in order to encourage connection the people around you.
                            <br/><br/>
                            The motivation of these interactions is to break a bit of tension and fear between each other.
                            </Text>
                        </Space>
                    </Col>
                </Row>
                
                <Row className="m80-t">
                    <Image src={require("../assets/projects/footui/footui_1.png")}/>
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        
        <Row className="whiteBG">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row justify="space-between" className="m80-t">
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                        <Space direction="vertical">
                            <Title className="whiteBGTitle">Prototype</Title>
                            <Text  className="whiteBGTitle">
                            Aim: to gauge the mood on the path.We started with exploring the space around a bus stop at Parque Nacional. Putting in 🙂😐🙁 on the ground with tape and footprints leading to them in chalk. And a message in spanish saying, "How are you doing today?"
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={15} xl={15}>
                        <Image className="m24-t" src={require("../assets/projects/footui/footui_2.png")}/>
                    </Col>
                </Row>
                <Row className="m16-t">
                    <Space size={16}>
                    <Image src={require("../assets/projects/footui/footui_3.png")}/>
                    <Image src={require("../assets/projects/footui/footui_4.png")}/>
                    </Space>
                    <Text  className="whiteBGTitle m16-t">
                        Some learnings:
                        <ul>
                            <li>
                                People may avoid stepping on your "art", possibly out of respect.
                            </li>
                            <li>
                                The city is full of colors, it takes a lot to get people's attention
                            </li>
                            <li>
                                During commuting times, people are tired and mainly trying to just get home.
                            </li>
                        </ul>
                    </Text>
                </Row>
                <Row className="m48-t m80-b">
                    <Text className="whiteBGTitle m16-b">
                    Based on our learnings, we reframed our problem statement:
                    </Text>
                    <Text className="m24-b HMW" >
                        how can we create small moments of casual interactions between people in public spaces in a way that encourages distancing and safety?
                    </Text>
                    <Text  className="whiteBGTitle m24-b m24-t">
                                Which led us to the markers on the floor which were a recent development in the urban environment outside government offices, supermarkets etc. as a more stable space to design an intervention for, with people waiting in queues.
                            </Text>
                    <Space size={16} className="m16-b">
                        <div>
                            <Image src={require("../assets/projects/footui/footui_5.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Markers we found outside a government office
                                </Text>
                            </div>
                        </div>
                    </Space>
                    <Space size={16} align="start" className="m16-t m16-b">
                        <div>
                            <Image src={require("../assets/projects/footui/footui_10.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Sharing circle - How can I invite someone in my mental space by sharing a physical space
                                </Text>
                            </div>
                        </div>
                        <div>
                            <Image src={require("../assets/projects/footui/footui_7.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Bodystorming to experience what this interaction might feel like
                                </Text>
                            </div>
                        </div>
                    </Space>
                    <Space size={16} align="start" className="m16-t m16-b">
                        <div>
                            <Image src={require("../assets/projects/footui/footui_6.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Projection mapped prototype using Resolume Arena - trying to materialize the experience
                                </Text>
                            </div>
                        </div>
                        <div>
                            <Image src={require("../assets/projects/footui/footui_9.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    p5.js + Resolume Arena - sharing via NDI - dynamic elements from p5.js to engage in a fun share-space
                                </Text>
                            </div>
                        </div>
                    </Space>                    
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row>
                    <Title>Experience Prototype</Title>
                </Row>
                <Row className="m16-t">
                    <Text>
                        We then went out to try our prototypes in person. Because of the COVID situation in San Jose, we tested out the interaction with members from the cohort.
                    </Text>
                </Row>
                <Row className="m48-t m80-b">
                    <Space size={16} align="start" className="m16-b">
                        <div>
                            <Image src={require("../assets/projects/footui/footui_11.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Top view - pedestrians playing with the Ball in the installation
                                </Text>
                            </div>
                        </div>
                    </Space>
                    <Space size={16} align="start" className="m16-t m16-b">
                        <div>
                            <Image src={require("../assets/projects/footui/footui_12.jpg")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    People began to place the ball in the start position - Carrying over of ritual from a normal ball game
                                </Text>
                            </div>
                        </div>
                        <div>
                            <Image src={require("../assets/projects/footui/footui_13.jpg")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Just me sitting on the staircase and controlling hte ball with the mouse - toggling between p5 and resolume.
                                </Text>
                            </div>
                        </div>
                    </Space>                 
                </Row>

                <Row className="m48-b">
                    <Col span={24}>
                            <div className="videoHeightIn">
                                <iframe src="https://player.vimeo.com/video/509588125?title=0&byline=0&portrait=0" className="vimeoChild" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                            </div>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Mohit and Sachin playing with the installation. Even though I was controlling the ball manually, they got lost in the experience, believing it was real.
                                </Text>
                            </div>
                    </Col>  
                </Row>

                <Row>
                    <Text className="projectTitle">Learnings from prototype</Text>
                </Row>

                <Row justify="space-between m16-t">
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                            
                            <Text>
                                <ul>
                                    <li>A few people started to notice the intervention.</li>
                                    <li>As there were no instructions, people were interacting with it as they felt like</li>
                                    <li>Unless inviting, people may avoid stepping on your "art", possibly out of respect.</li>
                                    <li>Because San Jose is full of colors, it takes a lot to get people's attention.</li>
                                    <li>During commuting times, people are tired and mainly trying to just get home.</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                            <Text>
                                <strong>Some reactions from the cohort members</strong>
                                <ul>
                                    <li><i>“It would be fun if there were some insects/ants on the ground to stamp” </i> - Mohit</li>
                                    <li><i>“Feels so real”</i> - Anonymous</li>
                                    <li><i>“I love how the ball comes back. I don’t have to fetch it”</i> - Ana</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                </Row>

            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
    </div>
  );
}

export default footUI;